import { apiGetAuth } from '@/utils/api'
import { API_LOG_ACTIVITY } from '@/utils/api-url'
import {
  notificationDanger
} from '@/utils/notification'

const state = {
  log_activity_list: {
    isLoading: false,
    data: {}
  },
  role_list: {
    isLoading: false,
    data: {}
  },
  module_list: {
    isLoading: false,
    data: {}
  },
  toggle_modal_add_edit_discard: {
    targetModals: false,  
    title: '',
    description: '',
    type: '',
    customTitleBtnOk: '',
    customTitleBtnCancel: '',
    customClass: '',
    loading: false,
    loadingPopUp: false
  },
  meta_filter: {
    order_by: 'updated_at',
    sort_by: 'desc'
  }
}

const mutations = {
  "SET_LOG_ACTIVITY_LIST": (state, payload) => {
    state.log_activity_list = payload
  },
  "SET_ROLE_LIST": (state, payload) => {
    state.role_list = payload
  },
  "SET_MODULE_LIST": (state, payload) => {
    state.module_list = payload
  },
  "SET_TOGGLE_MODAL_ADD_EDIT_DISCARD": (state, payload) => {
    state.toggle_modal_add_edit_discard = payload
  },
  "SET_META_FILTER": (state, payload) => {
    state.meta_filter = payload
  }
}

const actions = {
  async getLogActivityList(context, payload) {
    context.commit('SET_LOG_ACTIVITY_LIST', { isLoading: true })
    try {
      const response = await apiGetAuth(API_LOG_ACTIVITY.LIST, payload)
      context.commit('SET_LOG_ACTIVITY_LIST', {
        isLoading: false,
        data: response?.data
      })
    } catch (err) {
      context.commit('SET_LOG_ACTIVITY_LIST', {
        isLoading: false,
        data: {}
      })
      notificationDanger(err)
    }
  },
  async getRoleList(context, payload) {
    context.commit('SET_ROLE_LIST', { isLoading: true })
    try {
      const response = await apiGetAuth(API_LOG_ACTIVITY.LIST_ROLE, payload)
      context.commit('SET_ROLE_LIST', {
        isLoading: false,
        data: response?.data
      })
    } catch (err) {
      context.commit('SET_ROLE_LIST', {
        isLoading: false,
        data: {}
      })
      notificationDanger(err)
    }
  },
  async getModuleList(context, payload) {
    context.commit('SET_MODULE_LIST', { isLoading: true })
    try {
      const response = await apiGetAuth(API_LOG_ACTIVITY.LIST_MODULE, payload)
      context.commit('SET_MODULE_LIST', {
        isLoading: false,
        data: response?.data
      })
    } catch (err) {
      context.commit('SET_MODULE_LIST', {
        isLoading: false,
        data: {}
      })
      notificationDanger(err)
    }
  }
}

const getters = {
  get_log_acitivity_list: state => {
    return state.log_activity_list
  },
  get_role_list: state => {
    return state.role_list
  },
  get_module_list: state => {
    return state.module_list
  },
  get_toggle_modal_add_edit_discard: state => {
    return state.toggle_modal_add_edit_discard
  },
  meta_filter: state => {
    return state.meta_filter
  }
}

const namespaced = true
export default {
  namespaced,
  state,
  mutations,
  actions,
  getters
}
